// In-memory-only member token store.
// SECURITY: tokens are NEVER written to localStorage or sessionStorage.
// They live only for the current tab session; a page reload requires re-login.
let accessToken = null;
let refreshToken = null;
let sessionVersion = 0;
const endListeners = new Set();

export const memberToken = {
  getAccess: () => accessToken,
  getRefresh: () => refreshToken,
  getSessionVersion: () => sessionVersion,
  set: (access, refresh) => {
    // Login starts a new session; access-only renewal keeps its identity.
    if (refresh !== undefined) sessionVersion += 1;
    accessToken = access ?? null;
    if (refresh !== undefined) refreshToken = refresh ?? null;
  },
  clear: () => {
    sessionVersion += 1;
    accessToken = null;
    refreshToken = null;
  },
  // Ends the session (logout | expired | invalid): tokens are gone before the auth context is told.
  end: (reason) => {
    memberToken.clear();
    endListeners.forEach((fn) => fn(reason));
  },
  onEnd: (fn) => {
    endListeners.add(fn);
    return () => { endListeners.delete(fn); };
  },
};
